<template>
    <div v-if="showHours" class="hours">
        <span :class="hoursStyle"><fa-icon :icon="hoursIcon" aria-hidden="true"></fa-icon></span>
        <span>{{ statusMessage }}</span><br v-if="hoursMessage != ''" />
        <span class="message" v-if="hoursMessage != ''">{{ hoursMessage }}</span>
    </div>
</template>

<script>import script from './ListingHoursStatusDisplay';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingHoursStatusDisplay.less";
</style>
